import { render, staticRenderFns } from "./RelatorioOrdemDePagamentoGeralView.vue?vue&type=template&id=4ba188a8&scoped=true"
import script from "./RelatorioOrdemDePagamentoGeralView.vue?vue&type=script&lang=js"
export * from "./RelatorioOrdemDePagamentoGeralView.vue?vue&type=script&lang=js"
import style0 from "./RelatorioOrdemDePagamentoGeralView.vue?vue&type=style&index=0&id=4ba188a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba188a8",
  null
  
)

export default component.exports